import { Col, Form, FormInstance, Row, Typography } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';

import FloatingFormItem from '@/components/_common/FloatingFormItem';
import { useDefaultOnlyNumberRule } from '@/hooks';
import { InputText } from '@/components/_common';

const { Title } = Typography;

interface NcmIncomingFormProp {
  form: FormInstance;
  isModal?: boolean;
}

const NcmIncomingForm = ({ form, isModal }: NcmIncomingFormProp) => {
  const intl = useIntl();
  const defaultOnlyNumber = useDefaultOnlyNumberRule();

  return (
    <Form form={form}>
      <Title level={isModal ? 5 : 3}>
        <FormattedMessage id="ncm.incoming" />
      </Title>

      <Row gutter={[16, 16]}>
        <Col span={24} md={8} lg={8} xxl={6}>
          <FloatingFormItem
            name="cstIcmsEntry"
            label={intl.formatMessage({ id: 'ncm.domain.cstIcmsEntry' })}
            rules={[defaultOnlyNumber]}
          >
            <InputText onlyNumber />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8} lg={8} xxl={6}>
          <FloatingFormItem
            name="cstIpiEntry"
            label={intl.formatMessage({ id: 'ncm.domain.cstIpiEntry' })}
            rules={[defaultOnlyNumber]}
          >
            <InputText onlyNumber maxLength={4} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8} lg={8} xxl={6}>
          <FloatingFormItem
            name="cstPisEntry"
            label={intl.formatMessage({ id: 'ncm.domain.cstPisEntry' })}
            rules={[defaultOnlyNumber]}
          >
            <InputText onlyNumber />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8} lg={8} xxl={6}>
          <FloatingFormItem
            name="cstCofinsEntry"
            label={intl.formatMessage({ id: 'ncm.domain.cstCofinsEntry' })}
            rules={[defaultOnlyNumber]}
          >
            <InputText onlyNumber />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default NcmIncomingForm;
